import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpParams } from '@angular/common/http';
import { DatePipe } from '@angular/common';
import { Subject } from 'rxjs';
import { CommonService } from '../../common.service';
import { NgxSpinnerService } from "ngx-spinner";
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { CommonVariablesService } from '../../common-variables.service';
import * as XLSX from 'xlsx'

@Component({
  selector: 'app-country-subvoyage-mapping',
  templateUrl: './country-subvoyage-mapping.component.html',
})
export class CountrySubvoyageMappingComponent implements OnInit {
  countrySubvoyageMappingForm: FormGroup;
  dtTrigger: Subject<any> = new Subject();
  dtOptions: any;
  submitted = false;
  btnAddShow = false;
  btnUpdateShow = true;
  countryList: any = [];
  voyageNameList: any = [];
  voyageNameDropdownArr: any = [];
  displayCountrySubVoyageMappingResponse: any = [];
  countrySubvoyageMappingFormValue: any = [];
  countrySubVoyageMappingId: any;
  showFromCountryListArray: any = [];
  showToCountryListArray: any = [];
  dropdownSettings: IDropdownSettings = {};
  fromCountryArray: any = [];
  toCountryArray: any = [];
  voyageUniqueObject: any = {};
  fetchVoyageNameData: any = [];
  setSubVoyageArray: any = [];
  filterSubVoyageArray: any = [];
  count: number = 0;
  isViewMode: boolean;

  constructor(
    private formBuilder: FormBuilder,
    private datePipe: DatePipe,
    private commonService: CommonService,
    private commonVariablesService: CommonVariablesService,
    private spinner: NgxSpinnerService
  ) { }

  async ngOnInit() {
	window.localStorage.setItem('pageName','');
    this.countrySubvoyageMappingForm = this.formBuilder.group({
      policyType: ['', Validators.required],
      voyageName: ['', Validators.required],
      subVoyageType: ['', Validators.required],
      fromCountry: ['', Validators.required],
      toCountry: ['', Validators.required],

    });

    this.dropdownSettings = {
      singleSelection: false,
      idField: 'country_id',
      textField: 'country_name',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 5,
      allowSearchFilter: true
    };

    this.dtOptions = {
      dom: 'frtip',
      "pageLength": 50
    };

    /* let tmpUserType = this.cookie.get('userProfile'); */
    let tmpUserType = window.localStorage.getItem('userProfile');
    const getUserType = this.commonService.decryptData(tmpUserType);
    this.isViewMode = ((getUserType || '').toLowerCase() == 'adminview');

    await this.loadCountrySubVoyageMapping();
    await this.loadCountryList();
  }
  get f() { return this.countrySubvoyageMappingForm.controls; }

  /*
  * Created By : Keerthana
  * Description : This function will fetch the Country List.
  *********************************************/

  async loadCountryList() {
    let fetchCountryUrl = this.commonVariablesService.baseURL + 'api/v1/marine_master/fetchall/country_master';
    let fetchCountryData = await this.commonService.httpGetMethod(fetchCountryUrl, 'application/x-www-form-urlencoded', true, '', 'Country Sub-Voyage Mapping');
    this.countryList = [];

    for (let i = 0; i < fetchCountryData.data.length; i++) {
      if (fetchCountryData.data[i].status == 0) {
        this.countryList.push({ 'country_id': fetchCountryData.data[i].country_id, 'country_name': fetchCountryData.data[i].country_name });
      }
    }

    this.showFromCountryListArray = this.countryList;
    this.showToCountryListArray = this.countryList;
  }

  /*
  * Created By : Keerthana
  * Description : This function will fetch the voyage name.
  *********************************************/

  async loadVoyageNameList(policyType) {
    let objTitle;
    this.voyageNameDropdownArr = [];
    this.voyageUniqueObject = {};
    let fetchVoyageNameUrl = this.commonVariablesService.baseURL + 'api/v1/marine_master/fetchall/voyage/' + policyType;
    this.fetchVoyageNameData = await this.commonService.httpGetMethod(fetchVoyageNameUrl, 'application/x-www-form-urlencoded', true, '', 'Country Sub-Voyage Mapping');
    for (var i in this.fetchVoyageNameData.data) {
      objTitle = this.fetchVoyageNameData.data[i]['voyage_name'];
      this.voyageUniqueObject[objTitle] = this.fetchVoyageNameData.data[i];
    }
    for (var idx in this.voyageUniqueObject) {
      this.voyageNameDropdownArr.push(this.voyageUniqueObject[idx].voyage_name);
    }

    if (this.count > 0) {
      this.loadSubVoyageTypeList(this.countrySubvoyageMappingForm.value.voyageName)
    }
    else {
      this.countrySubvoyageMappingForm.patchValue({
        voyageName: '',
        subVoyageType: ''
      });
    }
  }

  /*
  * Created By : Keerthana
  * Description : This function is used to group the sub-voyage name.
  *********************************************/

  async loadSubVoyageTypeList(voyagename) {
    this.setSubVoyageArray = this.fetchVoyageNameData.data;
    this.filterSubVoyageArray = [];
    this.filterSubVoyageArray = this.setSubVoyageArray.filter((item) => {
      return item.voyage_name == voyagename;
    });

    if (this.count == 0) {
      this.countrySubvoyageMappingForm.patchValue({
        subVoyageType: this.filterSubVoyageArray[0].sub_voyage_name
      });
    }
  }

  /*
  * Created By : Keerthana
  * Description : This function will fetch the country sub voyage mapping details.
  *********************************************/

  async loadCountrySubVoyageMapping() {
    this.spinner.show();
    let table = $('#countrySubvoyageMappingDatatable').DataTable();
    table.destroy();
    let fetchCountrySubVoyageUrl = this.commonVariablesService.baseURL + 'api/v1/marine_master/fetchall/country_subvoyage_mapping';
    let tblData = await this.commonService.httpGetMethod(fetchCountrySubVoyageUrl, 'application/x-www-form-urlencoded', true, '', 'Country Sub-Voyage Mapping');
    this.displayCountrySubVoyageMappingResponse = [];

    if (tblData.status == 0) {
      for (var i = 0; i < tblData.data.length; i++) {
        //tblData.data[i].from_country=(tblData.data[i].from_country).replace(/~/g,",");
        //tblData.data[i].to_country=(tblData.data[i].to_country).replace(/~/g,",");
		tblData.data[i].u_ts = this.datePipe.transform(new Date(tblData.data[i].u_ts+" GMT").toISOString(),"dd-MM-yyyy HH:mm:ss")
        this.displayCountrySubVoyageMappingResponse.push(tblData.data[i]);
      }
    }
    else if (tblData.status != -114) {
      this.commonService.errorsmsg('Fetch Error', 'Error');
    }

    $('#searchPolicyType,#searchVoyageName,#searchSubVoyageName,#searchFromCountry,#searchToCountry,#searchUpdatedBy,#searchUpdatedTime').val('');
    this.dtTrigger.next();
  }

  /*
  * Created By : Keerthana
  * Description : This function will add the details in country sub voyage mapping .
  *********************************************/

  async addCountrySubVoyageMapping() {
    
    let ret: any = await this.checkCountrySubVoyageData();
    if (ret.status != 0) return;

    let addUrl = this.commonVariablesService.baseURL + 'api/v1/marine_master/add/country_subvoyage_mapping';
    let param = new HttpParams()
      .set('policy_type', this.countrySubvoyageMappingFormValue.policyType)
      .set('voyage_name', this.countrySubvoyageMappingFormValue.voyageName)
      .set('sub_voyage_name', this.countrySubvoyageMappingFormValue.subVoyageType)
      .set('from_country', ret.data.from_country)
      .set('to_country', ret.data.to_country)

    let addResponse = await this.commonService.httpPostMethod(addUrl, param, 'application/x-www-form-urlencoded; charset=UTF-8', true, 'Country Sub-Voyage Mapping');

    if (addResponse.body.status == 0) {
      this.commonService.successmsg('Country sub voyage mapping data added Successfully', 'Success');
      await this.loadCountrySubVoyageMapping();
      await this.resetForm();
    }
    else {
      if (addResponse.body.status != -114) {
        let tmp = (addResponse.body.data).split(' ');

        if (tmp[0] == 'Duplicate')
          this.commonService.errorsmsg('Policy Type/Voyage Name/Sub Voyage Name already exist', 'Error');
        else
          this.commonService.errorsmsg('Unable to add country sub voyage mapping data', 'Error');
      }
    }
  }

  /*
  * Created By : Keerthana
  * Description : This function will edit the details in country sub voyage mapping .
  *********************************************/

  editCountrySubVoyageMapping(oldResponse) {
    this.btnAddShow = true;
    this.btnUpdateShow = false;
    this.count++;
    this.loadVoyageNameList(oldResponse.policy_type);

    $('#countryMappingPolicyType').attr('disabled', 'true');
    $('#countryMappingVoyageName').attr('disabled', 'true');
    $('#countryMappingSubVoyageName').attr('disabled', 'true');

    this.fromCountryArray = [];
    this.toCountryArray = [];

    let fromArray = oldResponse.from_country.split('~');

    for (let i = 0; i < fromArray.length; i++) {
      for (let j = 0; j < this.countryList.length; j++) {
        if (fromArray[i] == this.countryList[j].country_name) {
          this.fromCountryArray.push({ 'country_id': this.countryList[j].country_id, 'country_name': fromArray[i] });
        }
      }
    }

    let toArray = oldResponse.to_country.split('~');

    for (let i = 0; i < toArray.length; i++) {
      for (let j = 0; j < this.countryList.length; j++) {
        if (toArray[i] == this.countryList[j].country_name) {
          this.toCountryArray.push({ 'country_id': this.countryList[j].country_id, 'country_name': toArray[i] });
        }
      }
    }

    this.countrySubvoyageMappingForm.patchValue({
      policyType: oldResponse.policy_type,
      voyageName: oldResponse.voyage,
      subVoyageType: oldResponse.sub_voyage,
      fromCountry: this.fromCountryArray,
      toCountry: this.toCountryArray
    });

    this.countrySubVoyageMappingId = oldResponse.mapped_id;
  }

  /*
  * Created By : Keerthana
  * Description : This function will reset the form .
  *********************************************/

  resetForm() {
    this.count = 0;
    this.countrySubvoyageMappingForm.reset();
    //this.showFromCountryListArray=[];
    //this.showToCountryListArray=[];
    this.voyageNameDropdownArr = [];
    this.filterSubVoyageArray = [];
    this.submitted = false;
    this.btnAddShow = false;
    this.btnUpdateShow = true;
    $('#countryMappingPolicyType').removeAttr('disabled');
    $('#countryMappingVoyageName').removeAttr('disabled');
    $('#countryMappingSubVoyageName').removeAttr('disabled');
    this.loadCountryList();
  }

  /*
  * Created By : Keerthana
  * Description : This function will update the details in country sub voyage mapping .
  *********************************************/

  async updateCountrySubVoyageMapping() {

    let ret: any = await this.checkCountrySubVoyageData();
    if (ret.status != 0) return;
    
    let updateUrl = this.commonVariablesService.baseURL + 'api/v1/marine_master/update/country_subvoyage_mapping';
    let updateParam = new HttpParams()
      .set('policy_type', this.countrySubvoyageMappingFormValue.policyType)
      .set('voyage_name', this.countrySubvoyageMappingFormValue.voyageName)
      .set('sub_voyage_name', this.countrySubvoyageMappingFormValue.subVoyageType)
      .set('from_country', ret.data.from_country)
      .set('to_country', ret.data.to_country)
      .set('id', this.countrySubVoyageMappingId)

    let addResponse = await this.commonService.httpPostMethod(updateUrl, updateParam, 'application/x-www-form-urlencoded; charset=UTF-8', true, 'Country Sub-Voyage Mapping');

    if (addResponse.body.status == 0) {
      this.commonService.successmsg('Country sub voyage mapping data updated sccessfully', 'Success');
      await this.loadCountrySubVoyageMapping();
      await this.resetForm();
    }
    else {
      if (addResponse.body.status != -114) {
        let tmp = (addResponse.body.data).split(' ');

        if (tmp[0] == 'Duplicate')
          this.commonService.errorsmsg('Policy Type/Voyage Name/Sub Voyage Name already exist', 'Error');
        else
          this.commonService.errorsmsg('Unable to update country sub voyage mapping data', 'Error');
      }
    }
  }

  /*
  * Created By : Keerthana
  * Description : This function will delete the details in country sub voyage mapping .
  *********************************************/
  async deleteCountrySubVoyageMapping(data) {
    let status = await this.commonService.deleteAlertMsg()
    if (status) {
      this.spinner.show();
      let deleteUrl = this.commonVariablesService.baseURL + 'api/v1/marine_master/delete/country_subvoyage_mapping/' + data.mapped_id;
      let response = await this.commonService.httpPostMethod(deleteUrl, '', 'application/x-www-form-urlencoded; charset=UTF-8', true, 'Country Sub-Voyage Mapping');

      if (response.body.status == 0) {
        this.commonService.warningmsg('Country sub voyage mapping data deleted successfully', 'Warning');
        await this.loadCountrySubVoyageMapping();
        await this.resetForm();
      }
      else if (response.body.status != -114) {
        this.commonService.errorsmsg('Unable to delete country sub voyage mapping data', 'Error');
      }
    }
  }

  /*
  * Created By : Keerthana
  * Description : This function will filter datatable according to search.
  *********************************************/

  filterBySearch() {
    let searchPolicyType = $("#searchPolicyType").val().toString().toLowerCase();
    let searchVoyageName = $("#searchVoyageName").val().toString().toLowerCase();
    let searchSubVoyageName = $("#searchSubVoyageName").val().toString().toLowerCase();
    let searchFromCountry = $("#searchFromCountry").val().toString().toLowerCase();
    let searchToCountry = $("#searchToCountry").val().toString().toLowerCase();
    let searchUpdatedBy = $("#searchUpdatedBy").val().toString().toLowerCase();
    let searchUpdatedTime = $("#searchUpdatedTime").val().toString().toLowerCase();

    let table = $("#countrySubvoyageMappingDatatable").DataTable();
    table.search('').columns().search('').draw();
    if (searchPolicyType != "") {
      table.column(0).search(searchPolicyType).draw();
    }
    if (searchVoyageName != "") {
      table.column(1).search(searchVoyageName).draw();
    }
    if (searchSubVoyageName != "") {
      table.column(2).search(searchSubVoyageName).draw();
    }
    if (searchFromCountry != "") {
      table.column(3).search(searchFromCountry).draw();
    }
    if (searchToCountry != "") {
      table.column(4).search(searchToCountry).draw();
    }
    if (searchUpdatedBy != "") {
      table.column(5).search(searchUpdatedBy).draw();
    }
    if (searchUpdatedTime != "") {
      table.column(6).search(searchUpdatedTime).draw();
    }
  }
  
  exportExcel()
	{
	   var tmpArray=[];
	   var tmpObj={};
	   
	   if(this.displayCountrySubVoyageMappingResponse.length>0)
	   {
		 for(var i=0;i<this.displayCountrySubVoyageMappingResponse.length;i++)
		 {
		  tmpObj={};
			tmpObj['policy_type']=this.displayCountrySubVoyageMappingResponse[i].policy_type;
			tmpObj['voyage']=this.displayCountrySubVoyageMappingResponse[i].voyage;
			tmpObj['sub_voyage']=this.displayCountrySubVoyageMappingResponse[i].sub_voyage;
			tmpObj['from_country']=this.displayCountrySubVoyageMappingResponse[i].from_country;
			tmpObj['to_country']=this.displayCountrySubVoyageMappingResponse[i].to_country;
			tmpObj['author']=this.displayCountrySubVoyageMappingResponse[i].author;
			tmpObj['u_ts']=this.displayCountrySubVoyageMappingResponse[i].u_ts;
			tmpArray.push(tmpObj)
		 }
		 var datajson= { datajson1: tmpArray };

		 var Heading = [
		   [],
		   ["Country Subvoyage Master"],
		   [],
		   ["Policy Type","Voyage Name","Sub-Voyage Name","From Country","To Country","Updated By","Updated Time"]
		 ];

		 const merge = [
			 { s: { r: 0, c: 0 }, e: { r: 0, c: 6 } },
			 { s: { r: 1, c: 0 }, e: { r: 1, c: 6 } },
			 { s: { r: 2, c: 0 }, e: { r: 2, c: 6 } },
			 /* { s: { r: 3, c: 0 }, e: { r: 3, c: 3 } }, */
		 ];
		 
		 var wscols = [];
		 //let cell;
		 for (let idx = 0; idx < Heading[3].length; idx++) 
		 {
			 wscols.push({ wch: 25 });  // Common column width
		 }
		 var ws = XLSX.utils.json_to_sheet(Heading);
		 ws['!cols'] = wscols;
		 ws["!merges"] = merge;
		 ws["A1"] = {
			 "t": 's',
			 /* "v": 'TATA MARINE', */
			 "s": { font: { size: 20, bold: true, color: "#e012e0", style: "text-align:center"} }
		 };
		 XLSX.utils.sheet_add_json(ws, datajson.datajson1, {
			 /* header: ["group_name","author","u_ts"], */
			 skipHeader: true,
			 origin: -1
		 });
		 // var alphabets = [''];
		 var wb = XLSX.utils.book_new();
		 XLSX.utils.book_append_sheet(wb, ws, "Country Subvoyage Master");
		 XLSX.writeFile(wb, 'Country_Subvoyage_Master.xlsx');
	   }
	   else
	   {
		this.commonService.errorsmsg("Unable to download excel,No data available in the table","Error"); 
	   }
   }
   
   /*
   * Created By : Sharann
   * Description : check the data before add/update.
   ***********************************************/
   checkCountrySubVoyageData() {
     
    return new Promise(resolve => {
      if (this.countrySubvoyageMappingForm.invalid) {
        this.submitted = true;
        return resolve({ status: -1, data: {} });
      }
      else {
        this.countrySubvoyageMappingFormValue = this.countrySubvoyageMappingForm.value;
        this.spinner.show();
  
        let from_country = "";
        let to_country = "";
  
        for (var i = 0; i < this.countrySubvoyageMappingFormValue.fromCountry.length; i++) {
          if (i < this.countrySubvoyageMappingFormValue.fromCountry.length - 1) {
            from_country += this.countrySubvoyageMappingFormValue.fromCountry[i].country_name + "~";
          }
          else {
            from_country += this.countrySubvoyageMappingFormValue.fromCountry[i].country_name
          }
        }
  
        for (var idx = 0; idx < this.countrySubvoyageMappingFormValue.toCountry.length; idx++) {
          if (idx < this.countrySubvoyageMappingFormValue.toCountry.length - 1) {
            to_country += this.countrySubvoyageMappingFormValue.toCountry[idx].country_name + "~";
          }
          else {
            to_country += this.countrySubvoyageMappingFormValue.toCountry[idx].country_name
          }
        }
  
        return resolve({ status: 0, data: { from_country: from_country, to_country: to_country } });
      }
    });
   }
}